import api from './api';
import { ApiResponse, FlagWithCount } from '../types';

export type FlagType = 'mmc' | 'plate' | 'detection';

/**
 * List all flags with their image counts
 * GET /flags/{type}/list
 */
export async function listFlags(type: FlagType): Promise<FlagWithCount[]> {
  const response = await api.get<ApiResponse<FlagWithCount[]>>(`flags/${type}/list`);
  return response.data.results || [];
}

/**
 * Create a new flag
 * POST /flags/{type}/create
 */
export async function createFlag(
  type: FlagType,
  label: string
): Promise<{ id: string }> {
  const response = await api.post<ApiResponse<{ id: string }>>(`flags/${type}/create`, { label });
  return response.data.results;
}

/**
 * Rename an existing flag
 * PATCH /flags/{type}/rename/{flag_id}
 */
export async function renameFlag(
  type: FlagType,
  flagId: string,
  label: string
): Promise<void> {
  await api.patch(`flags/${type}/rename/${flagId}`, { label });
}

/**
 * Delete a flag (removes from all images)
 * DELETE /flags/{type}/delete/{flag_id}
 */
export async function deleteFlag(type: FlagType, flagId: string): Promise<void> {
  await api.delete(`flags/${type}/delete/${flagId}`);
}

/**
 * Clear a flag from all images (without deleting the flag)
 * POST /flags/{type}/clear/{flag_id}
 */
export async function clearFlag(
  type: FlagType,
  flagId: string
): Promise<{ cleared: number }> {
  const response = await api.post<ApiResponse<{ cleared: number }>>(`flags/${type}/clear/${flagId}`);
  return response.data.results;
}
